import { ReactNode } from 'react';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { useViewportDevice } from '@zep/react';
import { Colors } from '@zep/ui-tokens';
import { ExportIcon } from '../../../../../icons';
import { AsideWithLayout } from '../../../../../layouts';
import { usePlanSpaceDetailContext } from '../../../plan';
export const PlanSpacesLayout = (props: SubScribedSpacesLayoutProps) => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    children,
    activeType
  } = props;
  const {
    spacePlan,
    readySpacePlans,
    space
  } = usePlanSpaceDetailContext();
  const {
    isMobile
  } = useViewportDevice();
  const targetAttribute = isMobile ? '_self' : '_blank';
  const menuItems = [{
    id: 0,
    isActive: activeType === 'plan',
    render: <Link style={{
      width: '100%'
    }} href={`/me/spaces/${spacePlan?.spaceHashId ?? readySpacePlans[0]?.readySpacePlan.spaceHashId}/plan`} prefetch={false}>
          {t('subscription:SpaceDetail.menu.manage')}
        </Link>
  }, {
    id: 1,
    isActive: activeType === 'billing',
    render: <Link style={{
      width: '100%'
    }} href={`/me/spaces/${spacePlan?.spaceHashId ?? readySpacePlans[0]?.readySpacePlan.spaceHashId}/plan/billing-history`} prefetch={false}>
          {t('subscription:SpaceList.button.toBillingHistory')}
        </Link>
  }, {
    id: 2,
    isActive: false,
    render: <Link href="/pricing" target={targetAttribute} style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '4px'
    }} prefetch={false}>
          <span>{t('subscription:SpaceDetail.menu.pricing')}</span>
          <ExportIcon width={16} height={16} color={Colors.Gray500} style={{
        display: 'inline-block'
      }} />
        </Link>
  }];
  return <AsideWithLayout.Wrapper data-sentry-element="unknown" data-sentry-component="PlanSpacesLayout" data-sentry-source-file="PlanSpacesLayout.tsx">
      <AsideWithLayout.Header title={t('subscription:SpaceList.paidSpaceManagement', '유료 스페이스 관리')} breadcrumbs={[t('subscription:Invoice.paymentInfo.space'), space.name]} data-sentry-element="unknown" data-sentry-source-file="PlanSpacesLayout.tsx" />
      <AsideWithLayout.Container data-sentry-element="unknown" data-sentry-source-file="PlanSpacesLayout.tsx">
        <AsideWithLayout.SideButtons menuItems={menuItems} data-sentry-element="unknown" data-sentry-source-file="PlanSpacesLayout.tsx" />
        <AsideWithLayout.Content data-sentry-element="unknown" data-sentry-source-file="PlanSpacesLayout.tsx">{children}</AsideWithLayout.Content>
      </AsideWithLayout.Container>
    </AsideWithLayout.Wrapper>;
};
type SubScribedSpacesLayoutProps = {
  spaceId?: number;
  breadcrumb?: string[];
  children: ReactNode;
  activeType?: 'billing' | 'plan';
};